<template>
  <div id="TecList" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 fixed-t">
        <div class="col-3 f18"><i class="iconfont icon-31fanhui1 color-primary" @click="$router.back(-1)"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">T</span>ecnicos</div>
        <div class="col-3 t-r f18"><i class="iconfont icon-plus color-primary" @click="user_add_on = true"></i></div>
    </div>
    <div class="h4"></div>
    <div class="col-12">
      <div class="col-12 mt5" v-for="(tec,tec_i) in data_list" v-bind:key="tec_i" @click="go_tec(tec.aid)">
        <div class="col-12">
          <div class="col-12 bg-color-white p5">
              <div class="col-2 f40 color-primary t-c">
                <img v-bind:src="tec.avatar" v-if="tec.avatar">
                <img src="@/assets/user.png" v-else class="w5 r50">
              </div>
              <div class="col-9 pl10">
                <div class="col-12 f16 uppercase pt10 pb2">{{ tec.name }}</div>
                <div class="col-12 color-muted f12">{{ tec.last_time}}</div>
              </div>
              <div class="col-1 color-muted t-r lh50"><i class="iconfont icon-31fanhui2"></i></div>
          </div>
        </div>
      </div>
    </div>
    <div ref="app_foot" class="col-12 fixed-b t-c color-white f14 bg-color1 t-c-v">
    </div>
    <div class="cover flex-c pl20 pr20" v-if="user_add_on">
      <div class="col-12 bg-color-white pt5 pb5 pr10 pl10">
        <div class="col-12 f14 bb1 pb5 lh30">
          <div class="col-8">Ingrese el nombre de usuario</div>
          <div class="col-4 t-r" @click="user_add_on = false">
            <i class="iconfont icon-31guanbi color-muted"></i>
          </div>
        </div>
        <div class="col-12 pt10 pb10 t-c">
          <div class="col-12 mb5"><input type="text" class="b1 lh38 pl3 pr3 r5 t-c f20" v-model="username"> </div>
        </div>
        <div class="col-12 bt1 pt10 pb5">
          <div class="col-12 bg-color-primary lh32 t-c color-white f14 r5" @click="add_user()">Guardar</div>
        </div>
      </div>  
    </div>  
  </div>
</template>
<script>
export default {
  name: 'TecList',
  data () {
    return {
      data_list: [],
      username: '',
      user_add_on: false
    }
  },
  created: function () {
    this.get_list_data();
  },
  methods: {
    get_list_data() {
      let post_data = {};
      if(this.$route.query.aid){
        post_data.aid = this.$route.query.aid;
      }
      this.post(this.api_url + 'Agent/tec_list', post_data).then((res)=>{
        if(res.status == 1){
          this.data_list = res.data;
        }
      })
    },
    go_tec(aid){
      this.$router.push({name:'Tec',query:{aid: aid}});
    },
    add_user(){
      let post_data = {};
      post_data.username = this.username;
      this.post(this.api_url + 'Agent/tec_add', post_data).then((res)=>{
        this.user_add_on = false;
        if(res.status == 1){
          this.$store.commit('setAlert',{type:'success',msg: "Éxito"});
          this.get_list_data();
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Agent/TecList.vue